<!-- 账号登录 -->

<template>
  <div>
    <el-form class="loginaccount" :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item class="login-row" prop="name">
        <el-input @keyup.enter.native="login" type="text" v-model="ruleForm.name" placeholder="输入账号" />
      </el-form-item>
      <el-form-item class="login-row" prop="pwd">
        <el-input @keyup.enter.native="login" :type="showPwd ? 'text' : 'password'" style="width: 85%"
          v-model="ruleForm.pwd" placeholder="密码" />
        <img v-show="!showPwd" src="../imgs/eye-no.svg" @click="showPwd = true" class="eye-icon" />
        <img v-show="showPwd" src="../imgs/eye.svg" @click="showPwd = false" class="eye-icon" />
      </el-form-item>

      <el-form-item class="forget"><span @click="retrieve">忘记密码</span></el-form-item>
      <!-- <div v-if="ruleForm.name && ruleForm.pwd" class="login-btn" @click="login">立即登录</div> -->
      <el-button class="login-btn" :disabled="ruleForm.name && ruleForm.pwd ? false : true" @click="login">
        立即登录
      </el-button>

      <!-- <div v-else class="login-btn disabled">立即登录</div> -->

      <div class="login-logon">
        没有账号？<span style="color: red" @click="register">立即注册</span>
      </div>
    </el-form>
  </div>
</template>

<script>
import { setlocalStorage } from "@/utils/auth"
import { getShopNum } from '@/api/shop.js'
export default {
  name: "accountLogin",
  data() {
    // 手机号码验证
    let validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("账号不能为空！"));
      }
      //使用正则表达式进行验证手机号码
      // if (!/^1[3456789]\d{9}$/.test(value)) {
      //   callback(new Error("手机号不正确！"));
      // }
      callback();
    };
    return {
      ruleForm: {
        name: "",
        pwd: "",
      },
      showPwd: false,
      form: {},
      rules: {
        name: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        pwd: [{ required: true, message: "密码不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {

    // 登录
    async login() {
      // 账号登录 存sessionStorage
      // console.log(this.ruleForm.name, this.ruleForm.pwd);
      // let params = {
      //   account: this.ruleForm.name,
      //   password: this.ruleForm.pwd,
      //   };

      const res = await this.$axios.post(`/weiXin/loginPass?account=${this.ruleForm.name}&password=${this.ruleForm.pwd}`)

      try {
        if (res.success) {
          let data = res.data
          this.userInfo = data
          window.localStorage.setItem('userInfo', JSON.stringify(data))
          window.localStorage.setItem('token', data.token)
          // 存购物车数量
          const num = await getShopNum()
          window.localStorage.setItem('shopNum', num.data)
          // window.location.href = "/";
          // console.log('登录成功');
          const backUrl = window.sessionStorage.getItem('backUrl')
          if (backUrl) {
            // 存token时间
            // window.localStorage.setItem('TOKEN_TIME', Date.now()) 
            this.$router.push(backUrl)
          } else {
            // 存token时间
            // window.localStorage.setItem('TOKEN_TIME', Date.now())
            this.$router.push('/')
            this.$message.success('登录成功！')
          }


        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        this.$message.error(e)
        // console.log('错误');
        // alert(e.message)
      }


      // this.$axios.post(`/weiXin/loginPass?account=${this.ruleForm.name}&password=${this.ruleForm.pwd}`).then(res => {
      //   // console.log(res)
      //   // let data = JSON.parse(res)
      //   if (res.code == '2000') {
      //     let data = res.data
      //     this.userInfo = data
      //     window.localStorage.setItem('userInfo', JSON.stringify(data))
      //     window.localStorage.setItem('token', data.token)
      //     // window.location.href = "/";
      //     this.$router.push('/')
      //     this.$message.success('登录成功！')
      //     // 存token时间
      //     setlocalStorage('TOKEN_TIME', Date.now())

      //   } else if (res.code == '5000') {
      //     this.$message.error(res.data);
      //   } else if (res.code == '5001') {
      //     this.$message.error(res.data);
      //   }

      // }).catch(err => {
      //   // alert(err)
      //   console.log(err);
      // })
    },
    // 打开注册页面
    register() {
      // let that = this;
      // that.loginShow = true;
      this.twoShow = true;
      this.$emit("transfer", this.twoShow)
    },
    // 打开忘记密码页面
    retrieve() {

      let that = this;
      // that.loginShow = true;
      that.twoShow = true;
      that.$emit("fun", that.twoShow)
    },
  },
};
</script>

<style lang="scss" scoped>
.loginaccount {
  padding: 20px 30px 30px 30px;
}

.login-row {
  /* margin-top: 78px; */
  // width: 420px;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 5px;
  margin-top: 48px;
}

.login-row input {
  font-size: 18px;
  outline: none;
  border: none;
  flex: 1;
  height: 22px;
}

.login-row>>>.el-input__inner {
  font-size: 18px;
  outline: none;
  border: none;
  flex: 1;
  height: 22px;
  width: 100%;
}

.login-row .eye-icon {
  width: 24px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
}

.forget {
  font-size: 14px;
  float: right;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #999999;
}

.login-btn {
  width: 100%;
  height: 50px;
  background-color: #db3a3b !important;
  margin-top: 90px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff !important;
  cursor: pointer;

  &:hover {
    background-color: #db3a3b !important;
    color: #ffffff !important;
  }
}

.login-btn.disabled {
  background-color: #db3a3b;
  cursor: not-allowed;
}

.login-logon {
  font-size: 14px;
  margin: 10px 130px;
}
</style>>



// WEBPACK FOOTER //
// src/components/accountLogin.vue